
import {
  computed, defineComponent,
} from 'vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { ETipoRelacaoPessoa } from '@/models/Enumeradores/Cadastros/Pessoas/ETipoRelacaoPessoa';
import { IPedidoCompra } from '@/models/Entidades/Compras/IPedidoCompra';

export default defineComponent({
  name: 'PedidoCompraDescontoAcrescimos',
  props: {
    pedidoCompra: {
      type: Object as () => IPedidoCompra,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CampoNumerico,
  },
  emits: ['update:notaFiscal', 'totalAlterado', 'percentualDescontoAlterado', 'descontoAlterado'],
  setup(props, { emit }) {
    const computedPedidoCompra = computed({
      get: () => props.pedidoCompra,
      set: (val: IPedidoCompra) => {
        emit('update:notaFiscal', val);
      },
    });

    function totalAlterado() {
      emit('totalAlterado');
    }

    return {
      props,
      ETipoRelacaoPessoa,
      computedPedidoCompra,
      totalAlterado,
    };
  },
});
